@if (!hcl.multiSectionFormConditionalLogicJSON.length) {
  <div class="alert alert-warning alert-dismissible fade show" role="alert">
    <button
      type="button"
      class="btn-close"
      data-bs-dismiss="alert"
      aria-label="Close"
    ></button>
    <strong
      >All the sections, subsections and fields are listed out in the preview by
      default as the conditional logic doesn't exist.</strong
    >
    Please go to Logic Builder and build logic to conditionally show/hide
    questions.
  </div>
}
